import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICES_API = buildApiTypeAction(GET_SERVICES, ApiActionTypes.REQUEST)
export const GET_SERVICES_API_SUCCESS = buildApiTypeAction(GET_SERVICES, ApiActionTypes.SUCCESS)
export const GET_SERVICES_API_ERROR = buildApiTypeAction(GET_SERVICES, ApiActionTypes.ERROR)

const UPSERT_SERVICE = 'UPSERT_SERVICE';
export const UPSERT_SERVICE_API = buildApiTypeAction(UPSERT_SERVICE, ApiActionTypes.REQUEST)
export const UPSERT_SERVICE_API_SUCCESS = buildApiTypeAction(UPSERT_SERVICE, ApiActionTypes.SUCCESS)
export const UPSERT_SERVICE_API_ERROR = buildApiTypeAction(UPSERT_SERVICE, ApiActionTypes.ERROR)

const GET_SERVICE_CATEGORIES = 'GET_SERVICE_CATEGORIES';
export const GET_SERVICE_CATEGORIES_API = buildApiTypeAction(GET_SERVICE_CATEGORIES, ApiActionTypes.REQUEST)
export const GET_SERVICE_CATEGORIES_API_SUCCESS = buildApiTypeAction(GET_SERVICE_CATEGORIES, ApiActionTypes.SUCCESS)
export const GET_SERVICE_CATEGORIES_API_ERROR = buildApiTypeAction(GET_SERVICE_CATEGORIES, ApiActionTypes.ERROR)

const UPSERT_SERVICE_CATEGORY = 'UPSERT_SERVICE_CATEGORY';
export const UPSERT_SERVICE_CATEGORY_API = buildApiTypeAction(UPSERT_SERVICE_CATEGORY, ApiActionTypes.REQUEST)
export const UPSERT_SERVICE_CATEGORY_API_SUCCESS = buildApiTypeAction(UPSERT_SERVICE_CATEGORY, ApiActionTypes.SUCCESS)
export const UPSERT_SERVICE_CATEGORY_API_ERROR = buildApiTypeAction(UPSERT_SERVICE_CATEGORY, ApiActionTypes.ERROR)

const GET_SERVICE_BY_ID = 'GET_SERVICE_BY_ID';
export const GET_SERVICE_BY_ID_API = buildApiTypeAction(GET_SERVICE_BY_ID, ApiActionTypes.REQUEST)
export const GET_SERVICE_BY_ID_API_SUCCESS = buildApiTypeAction(GET_SERVICE_BY_ID, ApiActionTypes.SUCCESS)
export const GET_SERVICE_BY_ID_API_ERROR = buildApiTypeAction(GET_SERVICE_BY_ID, ApiActionTypes.ERROR)

export const CLEAR_CURRENT_SERVICE = 'CLEAR_CURRENT_SERVICE'